import { RequestConfig, getLocale } from 'umi';
import { RequestOptionsInit } from 'umi-request';
import Cookie from 'js-cookie';
import { FAIL, SUCCESS } from '@/services/commonServiceErrorCode';
import { message } from 'antd';

const tokenRequestInterceptors = (url: string, options: RequestOptionsInit) => {
  const token = Cookie.get('kava_id_token');
  const token2 = localStorage.getItem('kava_id_token');
  const headers = {
    'x-locale': getLocale(),
    'x-access-token': token || token2,
    'wx-auth-token': token || token2,
    ...options.headers,
  };
  return {
    url,
    options: { ...options, interceptors: true, headers },
  };
};

interface IReason {
  reasonCode: string;
  reasonMsg: string;
}
export const requestConfig: RequestConfig = {
  timeout: 30000,
  errorConfig: {
    adaptor: (resData: any, ctx: any) => {
      let url = ctx.req.url;
      let isShowMessageToast = true;
      const method = ctx.req.options.method;
      const params = ctx.req.options.headers['x-custom-params'];

      try {
        const commonServiceErrorCode =
          window.__SENTRY_CONFIG__[`CommonServiceErrorCode_${getLocale()}`];
        const interfaceErrorCode =
          window.__SENTRY_CONFIG__[`InterfaceErrorCode_${getLocale()}`];
        const errorCode = JSON.parse(commonServiceErrorCode);
        const sencodCode = JSON.parse(interfaceErrorCode);
        if (params) {
          const paramBean = JSON.parse(params);
          if (paramBean.originUrl) {
            url = paramBean.originUrl;
          }
          if (paramBean.isShowError === false) {
            isShowMessageToast = paramBean.isShowError;
          }
        }
        url = `${url}:${method}`;

        resData.msg = errorCode[FAIL];
        if (errorCode.hasOwnProperty(resData.code)) {
          if (resData.code !== '060103') {
            //后续需要去掉这块，兼容旧版本结构体
            resData.msg = errorCode[resData.code];
          }
        }

        let key;
        Object.keys(sencodCode).forEach((item) => {
          if (item.includes(url)) {
            key = item;
          }
        });

        if (key) {
          const errorCodes = sencodCode[key];
          if (resData.code === '060103') {
            //后续需要去掉这块，兼容旧版本结构体
            const resonData = resData?.data as IReason;
            if (errorCodes.hasOwnProperty(resonData.reasonCode)) {
              resData.msg = errorCodes[resonData.reasonCode];
            }
          } else {
            if (errorCodes.hasOwnProperty(resData.code)) {
              resData.msg = errorCodes[resData.code];
            }
          }
        }
      } catch (e) {}

      if (resData.code !== SUCCESS && isShowMessageToast) {
        message.error(resData.msg);
      }
      return {
        ...resData,
        showType: 0,
      };
    },
  },
  middlewares: [],
  requestInterceptors: [tokenRequestInterceptors],
  credentials: 'include',
};
